import {
  addDays,
  addMonths,
  addYears,
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  isSameDay,
  differenceInCalendarDays,
} from 'date-fns';
import moment from 'moment-timezone';

const now = new Date()

const defineds = {
  startOfWeek: startOfWeek(now),
  endOfWeek: endOfWeek(now),
  startOfLastWeek: startOfWeek(addDays(now, -7)),
  endOfLastWeek: endOfWeek(addDays(now, -7)),
  startOfToday: startOfDay(now),
  endOfToday: endOfDay(now),
  startOfYesterday: startOfDay(addDays(now, -1)),
  endOfYesterday: endOfDay(addDays(now, -1)),
  startOfMonth: startOfMonth(now),
  endOfMonth: endOfMonth(now),
  startOfLastMonth: startOfMonth(addMonths(now, -1)),
  endOfLastMonth: endOfMonth(addMonths(now, -1)),
};

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    if(this.id !== 'Custom') {
      const definedRange = this.range();
      if(
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      ) {
        CustomRangeObject.startDate = range.startDate
        CustomRangeObject.endDate = range.endDate
        return true
      } else {
        return false
      }
    }

    for(let i = 0; i < DateRanges.length; i++) {
      if(DateRanges[i].id !== 'Custom') {
        const definedRange = DateRanges[i].range();
        if(
          isSameDay(range.startDate, definedRange.startDate) &&
          isSameDay(range.endDate, definedRange.endDate)
        ) {
          CustomRangeObject.startDate = range.startDate
          CustomRangeObject.endDate = range.endDate
          return false
        }
      }
    }
    CustomRangeObject.startDate = range.startDate
    CustomRangeObject.endDate = range.endDate
    return true
  },
};

function createStaticRanges(ranges) {
  return ranges.map(range => ({ ...staticRangeHandler, ...range }));
}

export const CustomRangeObject = {
  startDate: null,
  endDate: null,
  id: 'Custom',
}

export const DateRanges = createStaticRanges([
  {
    id: 'Today',
    label: 'Today',
    range: () => ({
      startDate: defineds.startOfToday,
      endDate: defineds.endOfToday,
      id: 'Today',
    }),
  },
  {
    id: 'Yesterday',
    label: 'Yesterday',
    range: () => ({
      startDate: defineds.startOfYesterday,
      endDate: defineds.endOfYesterday,
      id: 'Yesterday',
    }),
  },
  {
    id: 'This week',
    label: 'This week',
    range: () => ({
      startDate: defineds.startOfWeek,
      endDate: defineds.endOfWeek,
      id: 'This week',
    }),
  },
  {
    id: 'This month',
    label: 'This month',
    range: () => ({
      startDate: defineds.startOfMonth,
      endDate: defineds.endOfMonth,
      id: 'This month',
    }),
  },
  {
    id: 'Past 7 days',
    label: 'Past 7 days',
    range: () => ({
      startDate: addDays(now, -7),
      endDate: now,
      id: 'Past 7 days',
    }),
  },
  {
    id: 'Past 30 days',
    label: 'Past 30 days',
    range: () => ({
      startDate: addDays(now, -30),
      endDate: now,
      id: 'Past 30 days',
    }),
  },
  {
    id: 'Past 1 year',
    label: 'Past 1 year',
    range: () => ({
      startDate: addYears(now, -1),
      endDate: now,
      id: 'Past 1 year',
    }),
  },
  {
    id: 'Past 5 years',
    label: 'Past 5 years',
    range: () => ({
      startDate: addYears(now, -5),
      endDate: now,
      id: 'Past 5 years',
    }),
  },
  {
    id: 'Custom',
    label: 'Custom',
    range: () => CustomRangeObject
  },
]);


// WEBPACK FOOTER //
// ./src/common/components/DateRangeComponent/DateRanges.js